import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchStates as fetchStatesThunk,
  fetchDistricts as fetchDistrictsThunk,
  fetchLocalAreas as fetchLocalAreasThunk,
} from "../features/master/masterThunks";
import { clearDistricts } from "../features/master/masterSlice";
import { searchMerchantsThunk, fetchLocalAreasByDistrictThunk } from "../features/home/merchantSearchSlice";
import { Link } from "react-router-dom";
import Select from "react-select";
import { Building } from "lucide-react";

/* ===================== CONFIG ===================== */
const CARDS_PER_PAGE = 8; // 4 cards × 2 rows  

const BusinessSearch = () => {
  const dispatch = useDispatch();

  const { states, districts, loading: masterLoading } = useSelector(
    (state) => state.master
  );
  const { localAreas } = useSelector(
  (state) => state.merchantSearch   // ✅ CORRECT
);
  const { results, loading: searchLoading } = useSelector(
    (state) => state.merchantSearch
  );



  const merchants = results?.data?.merchants || [];

  /* ===================== STATE ===================== */
  const [keyword, setKeyword] = useState("");
  const [selectedState, setSelectedState] = useState("");
  const [selectedDistrict, setSelectedDistrict] = useState("");
  const [selectedLocalArea, setSelectedLocalArea] = useState("");
  const [currentPage, setCurrentPage] = useState(1);

  /* ===================== FETCH STATES ===================== */
   
  useEffect(() => {
    const INDIA_COUNTRY_ID = "68e8ef76a65b0a7d7ec75a29";
    dispatch(fetchStatesThunk(INDIA_COUNTRY_ID));
  }, [dispatch]);

  /* ===================== SEARCH ===================== */
 const handleSearch = () => {
  setCurrentPage(1);

  const payload = {
    page: 1,
    limit: 12,
  };

  // Send STATE NAME
  if (selectedState) {
    const stateObj = states.find(s => s._id === selectedState);
    if (stateObj) payload.stateName = stateObj.name;
  }

  // Send DISTRICT NAME
  if (selectedDistrict) {
    const districtObj = districts.find(d => d._id === selectedDistrict);
    if (districtObj) payload.districtName = districtObj.name;
  }

  // Send LOCAL AREA NAME
  if (selectedLocalArea) {
    payload.localAreaName = selectedLocalArea;
  }

  // Optional keyword search
  if (keyword && keyword.trim()) {
    payload.query = keyword.trim();
  }

  dispatch(searchMerchantsThunk(payload));
};


  /* ===================== DROPDOWN OPTIONS ===================== */
  const stateOptions = states.map((s) => ({
    value: s._id,
    label: s.name,
  }));

  const districtOptions = districts.map((d) => ({
    value: d._id,
    label: d.name,
  }));


  const localAreaOptions = localAreas.map((l) => ({
  value: l.name,   // NAME, not ID
  label: l.name,
}));


  /* ===================== PAGINATION LOGIC ===================== */
  const totalPages = Math.ceil(merchants.length / CARDS_PER_PAGE);

  const paginatedMerchants = merchants.slice(
    (currentPage - 1) * CARDS_PER_PAGE,
    currentPage * CARDS_PER_PAGE
  );

  return (
    <>
      {/* ================= HERO & SEARCH SECTION ================= */}
      <div className="business-search-section">
        <div className="container relative-z">
          <div className="row align-items-center">
            <div className="col-lg-8">
              <div className="hero-content-wrapper">
                <span className="top-subtext">Discover Local Services</span>
                <h1 className="business-search-hero-title">
                  Find the perfect <br />
                  <span className="accent-text">Business</span> for you
                </h1>

                <div className="business-search-search-container">
                  <div className="row g-3">

                    <div className="col-md-3">
                     <Select
  options={stateOptions}
  placeholder="Select State"
  value={stateOptions.find(o => o.value === selectedState) || null}
 onChange={(option) => {
  setSelectedState(option?.value || "");
  setSelectedDistrict("");
  setSelectedLocalArea("");
  dispatch(clearDistricts());
  if (option?.value) dispatch(fetchDistrictsThunk(option.value));
}}
  isClearable
  classNamePrefix="search-select"
  menuPortalTarget={document.body}
  menuPosition="fixed"
/>

                    </div>

                    <div className="col-md-3">
                  <Select
  options={districtOptions}
  placeholder="Select District"
  value={districtOptions.find(o => o.value === selectedDistrict) || null}
  onChange={(option) => {
    setSelectedDistrict(option?.value || "");
    setSelectedLocalArea("");

    if (option?.label) {
      // ✅ CORRECT thunk
      dispatch(fetchLocalAreasByDistrictThunk(option.label));
    }
  }}
  isDisabled={!selectedState || masterLoading}
  isClearable
  classNamePrefix="search-select"
  menuPortalTarget={document.body}
  menuPosition="fixed"
/>
                    </div>

                    <div className="col-md-3">
                   <Select
                   options={localAreaOptions}
                   placeholder="Select Local Area"
                    value={
                   localAreaOptions.find(o => o.value === selectedLocalArea) || null
    }
    onChange={(option) => setSelectedLocalArea(option?.value || "")}
    isDisabled={!selectedDistrict || masterLoading}
    isClearable
    classNamePrefix="search-select"
    menuPortalTarget={document.body}
    menuPosition="fixed"
  />
</div>


                    <div className="col-md-3 d-flex align-items-end">
                    <button
                      className="btn buisness-search-btn w-100"
                      onClick={handleSearch}
                      disabled={searchLoading}
                    >
                      {searchLoading ? "Searching..." : "SEARCH"}
                    </button>
                  </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Decorative Element */}
        <div className="decorative-hex-wrapper d-none d-lg-block">
          <div className="hex-outer">
            <div className="hex-inner">
               <img src="https://images.unsplash.com/photo-1556740758-90de374c12ad?auto=format&fit=crop&w=800&q=80" alt="Service" />
            </div>
          </div>
        </div>
      </div>

      {/* ================= RESULTS SECTION ================= */}
      <div className="results-section">
        <div className="container">
          <div className="results-header mb-3">
            <h2>Searched Merchants</h2>
            <p className="text-muted">
              Showing {merchants.length} verified businesses
            </p>
          </div>

          {/* ================= CARDS ================= */}
          <div className="row">
            {searchLoading ? (
              [1, 2, 3, 4].map((i) => (
                <div key={i} className="col-lg-3 col-md-6 mb-4">
                  <div className="skeleton-card"></div>
                </div>
              ))
            ) : paginatedMerchants.length === 0 ? (
              <div className="text-center py-5">
                <h4>No Merchant Found related to this Criteria</h4>
                <p className="text-muted">
                  Try adjusting your filters or search terms.
                </p>
              </div>
            ) : (
              paginatedMerchants.map((merchant) => (
                <div
                  key={merchant.merchantId}
                  className="col-lg-3 col-md-6 col-6 mb-4"
                >
                  <Link
                    to={`/merchant-detail/${merchant.merchantId}`}
                    className="text-decoration-none"
                  >
                    <div className="search-business-card h-100">
                      <div className="business-image-wrapper">
                         {merchant.businessLogo ? (
    <img
      src={`${process.env.REACT_APP_IMAGE_BASE_URL}${merchant.businessLogo}`}
      alt={merchant.businessName}
      className="business-image"
      loading="lazy"
      decoding="async"
    />
  ) : (
    <div className="no-logo-placeholder">
      <Building size={48} color="#6154A4" />
    </div>
  )}

                        {merchant.isSponsored && (
                          <span className="sponsored-tag">SPONSORED</span>
                        )}

                        <div className="category-tag">
                          {merchant.businessType || "Services"}
                        </div>
                      </div>

                      <div className="business-info">
                        <h3 className="business-name">
                          {merchant.businessName}
                        </h3>

                        <p className="text-muted small mb-1">
                          {merchant.district}, {merchant.state}
                        </p>

                        <p className="text-muted small">
                          {merchant.localArea}
                        </p>

                        <button className="view-profile-btn">
                          View Profile →
                        </button>
                      </div>
                    </div>
                  </Link>
                </div>
              ))
            )}
          </div>

          {/* ================= PAGINATION ================= */}
          {totalPages > 1 && (
            <div className="d-flex justify-content-center mt-4">
              <nav>
                <ul className="pagination">
                  <li
                    className={`page-item ${
                      currentPage === 1 ? "disabled" : ""
                    }`}
                  >
                    <button
                      className="page-link"
                      onClick={() =>
                        setCurrentPage((p) => Math.max(p - 1, 1))
                      }
                    >
                      Previous
                    </button>
                  </li>

                  {[...Array(totalPages)].map((_, i) => (
                    <li
                      key={i}
                      className={`page-item ${
                        currentPage === i + 1 ? "active" : ""
                      }`}
                    >
                      <button
                        className="page-link"
                        onClick={() => setCurrentPage(i + 1)}
                      >
                        {i + 1}
                      </button>
                    </li>
                  ))}

                  <li
                    className={`page-item ${
                      currentPage === totalPages ? "disabled" : ""
                    }`}
                  >
                    <button
                      className="page-link"
                      onClick={() =>
                        setCurrentPage((p) =>
                          Math.min(p + 1, totalPages)
                        )
                      }
                    >
                      Next
                    </button>
                  </li>
                </ul>
              </nav>
            </div>
          )}
        </div>
      </div>

      <style jsx>{`
       :root {
  --primary: #6154A4;
  --primary-dark: #4b4090;
  --accent: #ff9f43;
  --bg-light: #f8f9fa;
  --radius-lg: 28px;
  --radius-md: 18px;
}

/* ================= HERO SECTION ================= */

.business-search-section {
  background: linear-gradient(
    135deg,
    #f6e7ff 0%,
    #eef2ff 45%,
    #e8fff1 100%
  );
  padding: clamp(70px, 10vw, 130px) 0 clamp(110px, 14vw, 160px);
  position: relative;
  overflow: hidden;
}

.relative-z {
  position: relative;
  z-index: 5;
}

.top-subtext {
  color: var(--primary);
  font-weight: 800;
  letter-spacing: 2px;
  font-size: 0.8rem;
  margin-bottom: 12px;
  text-transform: uppercase;
}

.business-search-hero-title {
  font-size: clamp(2.2rem, 6vw, 4.2rem);
  font-weight: 900;
  line-height: 1.05;
  margin-bottom: 35px;
  color: #1f2937;
}

.accent-text {
  background: linear-gradient(90deg, var(--primary), #00c2ff);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

/* ================= SEARCH BAR ================= */

.business-search-search-container {
  background: rgba(255, 255, 255, 0.9);
  backdrop-filter: blur(16px);
  padding: 24px;
  border-radius: var(--radius-lg);
  box-shadow: 0 30px 60px rgba(0, 0, 0, 0.15);
  border: 1px solid rgba(255, 255, 255, 0.6);
}

.buisness-search-input {
  border-radius: var(--radius-md) !important;
  padding: 14px 18px !important;
  font-size: 0.95rem;
  border: 1px solid #e5e7eb !important;
}

.buisness-search-input:focus {
  border-color: var(--primary) !important;
  box-shadow: 0 0 0 4px rgba(97, 84, 164, 0.15) !important;
}

.buisness-search-btn {
  background: linear-gradient(
    135deg,
    var(--primary),
    var(--primary-dark)
  ) !important;
  border: none !important;
  border-radius: var(--radius-md) !important;
  padding: 14px !important;
  font-weight: 800 !important;
  letter-spacing: 1px;
  color: #fff !important;
  transition: all 0.3s ease;
}

.buisness-search-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 12px 24px rgba(97, 84, 164, 0.35);
}

.search-select__control {
  border-radius: 18px;
  min-height: 48px;
  border: 1px solid #e5e7eb;
  box-shadow: none;
}

.search-select__control--is-focused {
  border-color: #6154a497;
  box-shadow: 0 0 0 4px rgba(97, 84, 164, 0.15);
}

.search-select__menu {
  color: #3b2f77ff;
  background:  #ffffffff;
  border-radius: 14px;
  overflow: hidden;
  z-index: 9999;
}

.search-select__option--is-selected {
  background-color: #71699abb;
  color: #3b2f77ff;
}

.search-select__option--is-focused {
  background-color: rgba(97, 84, 164, 0.1);
}

.search-select__placeholder {
  color: #9ca3af;
  font-weight: 500;
}
  .search-select__menu-portal {
  z-index: 99999;
}


/* ================= DECORATION ================= */

.decorative-hex-wrapper {
  position: absolute;
  right: 3%;
  top: 50%;
  transform: translateY(-50%);
  opacity: 0.85;
}

.hex-outer {
  width: 400px;
  height: 400px;
  background: #fff;
  clip-path: polygon(25% 0%, 75% 0%, 100% 50%, 75% 100%, 25% 100%, 0% 50%);
  padding: 14px;
  box-shadow: 0 40px 80px rgba(0, 0, 0, 0.12);
}

.hex-inner {
  width: 100%;
  height: 100%;
  overflow: hidden;
  clip-path: inherit;
}

.hex-inner img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

/* ================= RESULTS ================= */

.results-section {
  background: #fff;
  border-radius: 48px 48px 0 0;
  margin-top: -32px;
  padding: clamp(60px, 8vw, 90px) 0;
  position: relative;
  box-shadow: 0 -12px 32px rgb(0 0 0 / 14%);
  z-index: 1;
  width:90%
}

.results-title {
  font-weight: 900;
  font-size: clamp(1.6rem, 3vw, 2.2rem);
}

/* ================= CARDS ================= */

.search-business-card {
  background: #fff;
  border-radius: 26px;
  border: 1px solid #f1f1f1;
  transition: all 0.35s ease;
  overflow: hidden;
}

@media (hover: hover) {
  .business-card:hover {
    transform: translateY(-10px);
    box-shadow: 0 25px 50px rgba(0, 0, 0, 0.08);
    border-color: var(--primary);
  }
}

.business-image-wrapper {
  position: relative;
  height: 170px;
  padding: 0.5rem;
}

.business-image {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.sponsored-tag {
  position: absolute;
  top: 14px;
  left: 14px;
  background: linear-gradient(135deg, #ff9f43, #ff7a18);
  color: #fff;
  padding: 4px 12px;
  border-radius: 10px;
  font-size: 0.7rem;
  font-weight: 800;
}

.category-tag {
  position: absolute;
  bottom: -14px;
  right: 18px;
  background: #fff;
  padding: 6px 14px;
  border-radius: 10px;
  font-weight: 800;
  font-size: 0.75rem;
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.12);
  color: var(--primary);
}

.business-info {
  padding: 28px 24px 24px;
}

.business-name {
  font-size: 1.2rem;
  font-weight: 900;
  color: #1f2937;
}

.location-box {
  display: flex;
  gap: 8px;
  font-size: 0.9rem;
  font-weight: 600;
}

.view-profile-btn {
  width: 100%;
  margin-top: 10px;
  padding: 6px;
  border-radius: 14px;
  border: 2px solid #e5e7eb;
  background: transparent;
  font-weight: 600;
  transition: all 0.3s ease;
   color: var(--primary);
}

.view-profile-btn:hover {
  background: var(--primary);
  color: #fff;
  border-color: var(--primary);
}

/* ================= MOBILE ================= */

@media (max-width: 768px) {

.results-section{
    margin-top: -133px;
    width:98%;
}

.category-tag{
 font-weight: 700;
  font-size: 0.65rem;
}
  .decorative-hex-wrapper {
    display: none;
  }

  .business-search-search-container {
    padding: 18px;
  }

  .search-business-card {
    // margin-bottom: 20px;
  }

  .business-info {
    padding: 15px;
  }
}

/* ================= SKELETON ================= */

.skeleton-card {
  height: 380px;
  border-radius: 26px;
  background: linear-gradient(
    90deg,
    #f0f0f0 25%,
    #e0e0e0 50%,
    #f0f0f0 75%
  );
  background-size: 200% 100%;
  animation: skeleton-loading 1.4s infinite;
}

@keyframes skeleton-loading {
  0% {
    background-position: 200% 0;
  }
  100% {
    background-position: -200% 0;
  }
}

.no-logo-placeholder {
  width: 100%;
  height: 100%;
  background: #f1f3f5;
  border-radius: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.no-logo-placeholder i {
  font-size: 3rem;
  color: #6154A4; /* match your theme */
}

@media (max-width: 576px) {
  .search-business-card {
    border-radius: 20px;
  }

  .text-muted{
  font-size:0.65rem;
  }

  .view-profile-btn {
  font-size:0.75rem;
  margin-top:0px;
  }


  .business-name {
    font-size: 0.75rem;
    margin-bottom:0px;
  }

  .business-image-wrapper {
    height: 140px;
  }
}

      `}</style>
    </>
  );
};

export default BusinessSearch;